export default {
    assets: {
        csv: 'assets/new-example.csv',
    },
    auth: {
        me: 'v2/me',
        login: 'v2/login',
        storageTokenKeyName: '_missi_token',
        storageUserKeyName: '_missi_user',
    },
    vessels: {
        all: 'v2/vessels',
        getDetail:
            'v2/vessels/{id}/history?from_date={startDate}&to_date={endDate}&with_meteorology={withMeteorology}&type={type}',
        getReport:
            'v2/vessels/{id}/report?from_date={startDate}&to_date={endDate}&with_meteorology={withMeteorology}&type={type}',
        getReportExport:
            'v2/vessels/{id}/report/{type}/export?from_date={startDate}&to_date={endDate}&with_meteorology={withMeteorology}&export_type={export_type}&is_dms={is_dms}',
        getVoyagesReportExport: 'v2/vessels/{id}/report/voyages/export',
        getDetailHistoryMeteorology: 'v2/vessels/{id}/history/{idHistory}/meteorology',
        getExpired: 'v2/vessels/expired?from_date={startDate}&to_date={endDate}&vessel_id={vessel}',
        edit: 'v2/settings/vessel/{id}',
    },
    zones: {
        all: 'v2/customer/zones',
        bulk: 'v2/customer/zones/bulk',
        getDetail: 'v2/customer/zones/{id}',
    },
    systemPorts: {
        all: 'v2/customer/system-ports',
        getDetail: 'v2/customer/system-ports/{id}',
    },
    routes: {
        all: 'v2/voyager/routes',
        byPorts: 'v2/voyager/routes-by-port',
        single: 'v2/voyager/route',
        getDetail: 'v2/voyager/route/{id}',
    },
    voyager: {
        all: 'v2/voyager/planners',
        single: 'v2/voyager/planner',
        getDetail: 'v2/voyager/planner/{id}',
        activate: 'v2/voyager/planner/{id}/activate',
        getAlarmVoyager: 'v2/voyager/planner/{id}/alarm',
    },
    notification: {
        settings: 'v2/settings/notification-alert',
        type: 'v2/settings/notification-type',
        all: 'v2/settings/notification-alert/{alias}/logs?page={page}&limit=10&orderBy={orderBy}&orderType={orderType}',
        read: 'v2/settings/notification-alert/{alias}/logs/read',
        create: 'v2/settings/notification-alert/{alias}',
        single: 'v2/settings/notification-alert/{alias}/{id}',
        unread: 'v2/settings/notification-alert/logs/unread',
    },
    alarm: {
        all: 'v2/settings/alarm/?page={page}&limit=10',
    },
    customer: {
        edit: 'v2/settings/customer/profile',
        settings: 'v2/settings/customer/appearence',
        editCrendetial: 'v2/settings/customer/credential',
        dashboard: 'v2/customer/dashboard',
    },
    fleet: {
        all: 'v2/settings/fleet',
        single: 'v2/settings/fleet/{id}',
    },
};
